import { createInstance } from '@optimizely/react-sdk';

const optimizely = createInstance({
  sdkKey: import.meta.env.VITE_OPTIMIZELY_KEY,
  eventBatchSize: 10,
  eventFlushInterval: 1000,
  odpOptions: {
    disabled: true,
  },
});

export { optimizely };
